import { GetCampaignPerformanceByProperty } from '../../../../../Services/PerformanceInsights/CampaignInsightsService';
import useFetchData from '../../../../../Hooks/useFetchData';

const useFetchCampaignPerformance = (body) =>
  useFetchData(GetCampaignPerformanceByProperty, body);

export default useFetchCampaignPerformance;
